import React from "react";
import { Col, Divider, Flex, Row, Typography } from "antd";

export interface LimitDetailProps{
    description: string;
    title: string;
    perps: string[];
    tripped: boolean | null | undefined;
}

const { Title, Text } = Typography;

const LimitDetails : React.FC<LimitDetailProps> = ({ description, title, perps }) => {

    return(
        <Flex justify='center' vertical style={{ maxWidth:'800px', paddingTop: '8px', paddingBottom: '8px' }}>
            <Row justify={'center'} align={'top'}>
                <Title level={3}>{title}</Title>
            </Row>
            <Row justify={'center'}>
                <Col span={20}>
                    <Text>
                        {description}
                    </Text>
                    <br/>
                    <Divider/>
                    <Text>
                        Perpetrators: {perps.join(', ')}
                    </Text>
                    <br/>
                </Col>
            </Row>
        </Flex>
    )
}

export default LimitDetails;